import { createPath } from "@odata/BindingContext";
import {
    EntitySetName,
    EntityTypeName,
    PrCSSZSubmissionCaregivingDetailEntity,
    PrCSSZSubmissionEmployerConfirmationIllnessLeaveEntity,
    PrCSSZSubmissionIllnessLeaveDetailEntity,
    PrCSSZSubmissionIllnessLeaveEntity,
    PrCSSZSubmissionMaternityLeaveDetailEntity
} from "@odata/GeneratedEntityTypes";
import { PrSubmissionSubtypeCode, PrSubmissionTypeCode } from "@odata/GeneratedEnums";
import { setDefByEntityType } from "@pages/getDefByEntityType";
import { IDefinition, IGetDefinition } from "@pages/PageUtils";
import {
    getDefinitions as commonDef,
    getSubmissionFormDef,
    IGetSubmissionDefArgs,
    PrSubmissionGroup
} from "@pages/payroll/submission/Submission.def";
import {
    addCommonNEMPRIDefinitions,
    addCSSZSwitchDef,
    addMaternityRelatedFieldDefinitions,
    addPensionFieldsDefinitions,
    addStudyFieldDefinitions,
    addWorkLeaveWithoutPayFieldDefinitions,
    CSSZTranslationFiles,
    distrainmentAndInsolvencyFields
} from "@pages/payroll/submission/submissionTypes/PrCSSZSubmission.utils";
import PrCSSZSubmissionIllnessLeaveFormView
    from "@pages/payroll/submission/submissionTypes/PrCSSZSubmissionIllnessLeaveFromView";
import { cloneDeep } from "lodash";

import { IAppContext } from "../../../../contexts/appContext/AppContext.types";
import { addRowsToGroup } from "../../../../views/formView/Form.utils";

export const getDefinitions: IGetDefinition = (context: IAppContext, args?: IGetSubmissionDefArgs): IDefinition => {
    const d = cloneDeep(getSubmissionFormDef(PrCSSZSubmissionIllnessLeaveFormView, context, {
        ...args,
        type: PrSubmissionTypeCode.EmployersNotificationOfAnEmployeesBenefitApplication,
        subType: PrSubmissionSubtypeCode.NempriIllnessLeave
    }));

    // shared definitions with All other CSSZ submissions
    addCommonNEMPRIDefinitions(d, context, args);

    // **************** Pension, Previous maternity, Insolvency, Distrainment, ... ****************
    const pensionRows = addPensionFieldsDefinitions(d, PrCSSZSubmissionMaternityLeaveDetailEntity);
    // Student status
    const studyRows = addStudyFieldDefinitions(d, PrCSSZSubmissionCaregivingDetailEntity);
    // Work leave without pay
    const workLeaveWithoutPayRows = addWorkLeaveWithoutPayFieldDefinitions(d, PrCSSZSubmissionCaregivingDetailEntity);
    // Maternity related fields
    const maternityRelatedRows = addMaternityRelatedFieldDefinitions(d, PrCSSZSubmissionCaregivingDetailEntity, { enhanced: true });
    const distrainmentAndInsolvencyRows = distrainmentAndInsolvencyFields(d, PrCSSZSubmissionMaternityLeaveDetailEntity);

    const isFirstEmploymentLeavePath = createPath(PrCSSZSubmissionIllnessLeaveEntity.Detail, PrCSSZSubmissionIllnessLeaveDetailEntity.EmployerConfirmation, PrCSSZSubmissionEmployerConfirmationIllnessLeaveEntity.IsFirstEmploymentLeave);
    addCSSZSwitchDef(d, isFirstEmploymentLeavePath, "IsFirstEmploymentLeave");

    // Enhance group def
    const rows = [
        ...pensionRows,
        ...studyRows,
        [{ id: isFirstEmploymentLeavePath }],
        ...workLeaveWithoutPayRows,
        ...maternityRelatedRows,
        ...distrainmentAndInsolvencyRows
    ];
    addRowsToGroup(d, PrSubmissionGroup.IncomeInPeriod, rows);

    return {
        ...d,
        entitySet: EntitySetName.PrCSSZSubmissionsIllnessLeave
    };
};

getDefinitions.translationFiles = [
    ...commonDef.translationFiles,
    ...CSSZTranslationFiles,
];
setDefByEntityType(EntityTypeName.PrCSSZSubmissionIllnessLeave, getDefinitions);